// Code generated by protoc-gen-synurang-ffi. DO NOT EDIT.
// Source: volvoxgrid.v1

import * as pb from "./volvoxgrid_lite.js";

export const PROTO_PACKAGE = "volvoxgrid.v1" as const;
export enum AggregateType {
  AGG_NONE = 0,
  AGG_CLEAR = 1,
  AGG_SUM = 2,
  AGG_PERCENT = 3,
  AGG_COUNT = 4,
  AGG_AVERAGE = 5,
  AGG_MAX = 6,
  AGG_MIN = 7,
  AGG_STD_DEV = 8,
  AGG_VAR = 9,
  AGG_RANGE = 10,
  AGG_COUNT_ALL = 11,
  AGG_MEDIAN = 12,
  AGG_COUNT_DISTINCT = 13,
}
export enum Align {
  ALIGN_LEFT_TOP = 0,
  ALIGN_LEFT_CENTER = 1,
  ALIGN_LEFT_BOTTOM = 2,
  ALIGN_CENTER_TOP = 3,
  ALIGN_CENTER_CENTER = 4,
  ALIGN_CENTER_BOTTOM = 5,
  ALIGN_RIGHT_TOP = 6,
  ALIGN_RIGHT_CENTER = 7,
  ALIGN_RIGHT_BOTTOM = 8,
  ALIGN_GENERAL = 9,
}
export enum ApplyScope {
  APPLY_SINGLE = 0,
  APPLY_SELECTION = 1,
}
export enum ArchiveRequest_Action {
  ACTION_UNSPECIFIED = 0,
  SAVE = 1,
  LOAD = 2,
  DELETE = 3,
  LIST = 4,
}
export enum AutoSizeMode {
  AUTOSIZE_BOTH = 0,
  AUTOSIZE_COL_WIDTH = 1,
  AUTOSIZE_ROW_HEIGHT = 2,
}
export enum BarcodeCaptionPosition {
  CAPTION_NONE = 0,
  CAPTION_BOTTOM = 1,
  CAPTION_TOP = 2,
}
export enum BarcodeCheckDigitMode {
  CHECK_DIGIT_DEFAULT = 0,
  CHECK_DIGIT_NONE = 1,
  CHECK_DIGIT_GENERATE = 2,
}
export enum BarcodeQrErrorCorrection {
  QR_ECC_DEFAULT = 0,
  QR_ECC_LOW = 1,
  QR_ECC_MEDIUM = 2,
  QR_ECC_QUARTILE = 3,
  QR_ECC_HIGH = 4,
}
export enum BarcodeRenderStatus {
  BARCODE_RENDER_STATUS_UNSPECIFIED = 0,
  BARCODE_RENDER_STATUS_OK = 1,
  BARCODE_RENDER_STATUS_EMPTY_PAYLOAD = 2,
  BARCODE_RENDER_STATUS_INVALID_PAYLOAD = 3,
  BARCODE_RENDER_STATUS_UNSUPPORTED_SYMBOLOGY = 4,
}
export enum BarcodeSymbology {
  BARCODE_NONE = 0,
  BARCODE_QR = 1,
  BARCODE_CODE128 = 10,
  BARCODE_CODE39 = 11,
  BARCODE_CODE93 = 12,
  BARCODE_CODE11 = 13,
  BARCODE_EAN13 = 20,
  BARCODE_EAN8 = 21,
  BARCODE_UPC_A = 22,
  BARCODE_UPC_E = 23,
  BARCODE_EAN_SUPP = 24,
  BARCODE_ITF = 30,
  BARCODE_STF = 31,
  BARCODE_CODABAR = 32,
}
export enum BarcodeTextEncoding {
  BARCODE_TEXT_AUTO = 0,
  BARCODE_TEXT_ASCII = 1,
  BARCODE_TEXT_UTF8 = 2,
  BARCODE_TEXT_GS1 = 3,
}
export enum BorderAppearance {
  BORDER_APPEARANCE_FLAT = 0,
  BORDER_APPEARANCE_RAISED = 1,
  BORDER_APPEARANCE_SUBTLE = 2,
}
export enum BorderStyle {
  BORDER_NONE = 0,
  BORDER_THIN = 1,
  BORDER_THICK = 2,
  BORDER_DOTTED = 3,
  BORDER_DASHED = 4,
  BORDER_DOUBLE = 5,
}
export enum ButtonRole {
  BUTTON_ROLE_DEFAULT = 0,
  BUTTON_ROLE_ELLIPSIS = 1,
  BUTTON_ROLE_CLEAR = 2,
  BUTTON_ROLE_CUSTOM = 3,
}
export enum CellHitArea {
  HIT_CELL = 0,
  HIT_TEXT = 1,
  HIT_PICTURE = 2,
  HIT_BUTTON = 3,
  HIT_CHECKBOX = 4,
  HIT_DROPDOWN = 5,
}
export enum CellInteraction {
  CELL_INTERACTION_UNSPECIFIED = 0,
  CELL_INTERACTION_NONE = 1,
  CELL_INTERACTION_TEXT_LINK = 2,
  CELL_INTERACTION_BUTTON = 3,
}
export enum CellSpanMode {
  CELL_SPAN_NONE = 0,
  CELL_SPAN_FREE = 1,
  CELL_SPAN_BY_ROW = 2,
  CELL_SPAN_BY_COLUMN = 3,
  CELL_SPAN_ADJACENT = 4,
  CELL_SPAN_HEADER_ONLY = 5,
  CELL_SPAN_SPILL = 6,
  CELL_SPAN_GROUP = 7,
}
export enum CheckedState {
  CHECKED_UNCHECKED = 0,
  CHECKED_CHECKED = 1,
  CHECKED_GRAYED = 2,
}
export enum ClearRegion {
  CLEAR_SCROLLABLE = 0,
  CLEAR_FIXED_ROWS = 1,
  CLEAR_FIXED_COLS = 2,
  CLEAR_FIXED_BOTH = 3,
  CLEAR_ALL_ROWS = 4,
  CLEAR_ALL_COLS = 5,
  CLEAR_ALL_BOTH = 6,
}
export enum ClearScope {
  CLEAR_SCOPE_UNSPECIFIED = 0,
  CLEAR_EVERYTHING = 1,
  CLEAR_FORMATTING = 2,
  CLEAR_DATA = 3,
  CLEAR_SELECTION = 4,
}
export enum CoercionMode {
  COERCION_UNSPECIFIED = 0,
  COERCION_STRICT = 1,
  COERCION_FLEXIBLE = 2,
  COERCION_PARSE_ONLY = 3,
}
export enum ColIndicatorCellMode {
  COL_INDICATOR_CELL_NONE = 0,
  COL_INDICATOR_CELL_HEADER_TEXT = 1,
  COL_INDICATOR_CELL_SORT_GLYPH = 2,
  COL_INDICATOR_CELL_SORT_PRIORITY = 4,
  COL_INDICATOR_CELL_FILTER_BUTTON = 8,
  COL_INDICATOR_CELL_FILTER_STATE = 16,
  COL_INDICATOR_CELL_MENU_BUTTON = 32,
  COL_INDICATOR_CELL_CHOOSER = 64,
  COL_INDICATOR_CELL_DRAG_REORDER = 128,
  COL_INDICATOR_CELL_HIDDEN_MARKER = 256,
  COL_INDICATOR_CELL_RESIZE_HANDLE = 512,
  COL_INDICATOR_CELL_SELECT_ALL = 1024,
  COL_INDICATOR_CELL_STATUS_ICON = 2048,
  COL_INDICATOR_CELL_CUSTOM = 4096,
}
export enum ColumnDataType {
  COLUMN_DATA_STRING = 0,
  COLUMN_DATA_NUMBER = 1,
  COLUMN_DATA_DATE = 2,
  COLUMN_DATA_BOOLEAN = 3,
  COLUMN_DATA_CURRENCY = 4,
}
export enum ComposeMethod {
  COMPOSE_METHOD_NONE = 0,
  COMPOSE_METHOD_HANGUL = 1,
  COMPOSE_METHOD_DEAD_KEY = 2,
  COMPOSE_METHOD_TELEX = 3,
}
export enum CornerIndicatorSlotKind {
  CORNER_SLOT_NONE = 0,
  CORNER_SLOT_SELECT_ALL = 1,
  CORNER_SLOT_OUTLINE_LEVELS = 2,
  CORNER_SLOT_CUSTOM = 3,
}
export enum CursorType {
  CURSOR_DEFAULT = 0,
  CURSOR_RESIZE_COL = 1,
  CURSOR_RESIZE_ROW = 2,
  CURSOR_MOVE_COL = 3,
  CURSOR_TEXT = 4,
  CURSOR_HAND = 5,
  CURSOR_MOVE_ROW = 6,
  CURSOR_WAIT = 7,
  CURSOR_NOT_ALLOWED = 8,
  CURSOR_CROSSHAIR = 9,
  CURSOR_COPY = 10,
}
export enum CustomRenderMode {
  CUSTOM_RENDER_NONE = 0,
  CUSTOM_RENDER_CELL = 1,
  CUSTOM_RENDER_ROW = 2,
}
export enum DemoDataFormat {
  DEMO_DATA_FORMAT_UNSPECIFIED = 0,
  DEMO_DATA_FORMAT_JSON = 1,
}
export enum DragMode {
  DRAG_NONE = 0,
  DRAG_MANUAL = 1,
  DRAG_AUTOMATIC = 2,
}
export enum DropMode {
  DROP_NONE = 0,
  DROP_MANUAL = 1,
  DROP_AUTOMATIC = 2,
}
export enum DropdownItemLayout {
  DROPDOWN_ITEM_AUTO = 0,
  DROPDOWN_ITEM_LABEL = 1,
  DROPDOWN_ITEM_VALUE_LABEL = 2,
  DROPDOWN_ITEM_LABEL_DETAILS = 3,
}
export enum EditEndReason {
  EDIT_END_UNSPECIFIED = 0,
  EDIT_END_COMMITTED = 1,
  EDIT_END_CANCELED = 2,
  EDIT_END_REVERTED_INVALID = 3,
  EDIT_END_FOCUS_LOST = 4,
  EDIT_END_CELL_REMOVED = 5,
  EDIT_END_GRID_DESTROYED = 6,
}
export enum EditStartReason {
  EDIT_START_UNSPECIFIED = 0,
  EDIT_START_F2 = 1,
  EDIT_START_DOUBLE_CLICK = 2,
  EDIT_START_CLICK_CARET = 3,
  EDIT_START_ENTER_KEY = 4,
  EDIT_START_PRINTABLE_KEY = 5,
  EDIT_START_IME_COMPOSITION = 6,
  EDIT_START_DROPDOWN_BUTTON = 7,
  EDIT_START_PROGRAMMATIC = 8,
}
export enum EditTrigger {
  EDIT_TRIGGER_NONE = 0,
  EDIT_TRIGGER_KEY = 1,
  EDIT_TRIGGER_KEY_CLICK = 2,
}
export enum EditUiMode {
  EDIT_UI_MODE_ENTER = 0,
  EDIT_UI_MODE_EDIT = 1,
}
export enum EditorKind {
  EDITOR_KIND_UNSPECIFIED = 0,
  EDITOR_TEXT = 1,
  EDITOR_MULTILINE_TEXT = 2,
  EDITOR_NUMBER = 3,
  EDITOR_CHECKBOX = 4,
  EDITOR_SELECT = 5,
  EDITOR_COMBO = 6,
  EDITOR_DATE_TIME = 7,
  EDITOR_BUTTON = 8,
  EDITOR_CUSTOM = 100,
}
export enum EditorOwner {
  EDITOR_OWNER_ENGINE = 0,
  EDITOR_OWNER_HOST_NATIVE = 1,
  EDITOR_OWNER_CUSTOM = 2,
}
export enum EditorPresentation {
  EDITOR_CANVAS = 0,
  EDITOR_POPUP_OVER = 1,
  EDITOR_POPUP_UNDER = 2,
  EDITOR_MODAL = 3,
  EDITOR_INLINE = 4,
}
export enum EditorUpdateReason {
  EDITOR_UPDATE_UNSPECIFIED = 0,
  EDITOR_UPDATE_GEOMETRY = 1,
  EDITOR_UPDATE_VALIDATION = 2,
  EDITOR_UPDATE_NORMALIZED_VALUE = 3,
  EDITOR_UPDATE_PROGRAMMATIC_VALUE = 4,
  EDITOR_UPDATE_REMOTE_VALUE = 5,
  EDITOR_UPDATE_CUSTOM_PAYLOAD = 6,
}
export enum ErrorCode {
  ERROR_UNKNOWN = 0,
  ERROR_INVALID_ARGUMENT = 1,
  ERROR_NOT_FOUND = 2,
  ERROR_INVALID_STATE = 3,
  ERROR_TYPE_VIOLATION = 4,
  ERROR_DECODE_FAILED = 5,
  ERROR_ENCODE_FAILED = 6,
  ERROR_NOT_IMPLEMENTED = 7,
  ERROR_INTERNAL = 8,
}
export enum ExportFormat {
  EXPORT_FORMAT_UNSPECIFIED = 0,
  EXPORT_BINARY = 1,
  EXPORT_TSV = 2,
  EXPORT_CSV = 3,
  EXPORT_DELIMITED = 4,
  EXPORT_XLSX = 5,
}
export enum ExportScope {
  EXPORT_SCOPE_UNSPECIFIED = 0,
  EXPORT_ALL = 1,
  EXPORT_DATA_ONLY = 2,
  EXPORT_FORMAT_ONLY = 3,
}
export enum FillHandlePosition {
  FILL_HANDLE_NONE = 0,
  FILL_HANDLE_BOTTOM_RIGHT = 1,
  FILL_HANDLE_BOTTOM_LEFT = 2,
  FILL_HANDLE_TOP_RIGHT = 3,
  FILL_HANDLE_TOP_LEFT = 4,
  FILL_HANDLE_ALL_CORNERS = 5,
}
export enum FocusBorderStyle {
  FOCUS_BORDER_NONE = 0,
  FOCUS_BORDER_THIN = 1,
  FOCUS_BORDER_THICK = 2,
  FOCUS_BORDER_INSET = 3,
  FOCUS_BORDER_RAISED = 4,
}
export enum FrameKind {
  FRAME_KIND_FRAME = 0,
  FRAME_KIND_SESSION_START = 1,
  FRAME_KIND_SESSION_END = 2,
}
export enum FramePacingMode {
  FRAME_PACING_MODE_AUTO = 0,
  FRAME_PACING_MODE_PLATFORM = 1,
  FRAME_PACING_MODE_UNLIMITED = 2,
  FRAME_PACING_MODE_FIXED = 3,
}
export enum GridEventTargetFlag {
  GRID_TARGET_FLAG_NONE = 0,
  GRID_TARGET_FLAG_CHECKED = 1,
  GRID_TARGET_FLAG_INDETERMINATE = 2,
  GRID_TARGET_FLAG_EXPANDED = 4,
  GRID_TARGET_FLAG_COLLAPSED = 8,
  GRID_TARGET_FLAG_SORT_ASC = 16,
  GRID_TARGET_FLAG_SORT_DESC = 32,
  GRID_TARGET_FLAG_FILTER_ACTIVE = 64,
  GRID_TARGET_FLAG_SELECTED = 128,
  GRID_TARGET_FLAG_DISABLED = 256,
  GRID_TARGET_FLAG_EDITING = 512,
  GRID_TARGET_FLAG_SUBTOTAL = 1024,
  GRID_TARGET_FLAG_PINNED = 2048,
}
export enum GridLineDirection {
  GRIDLINE_BOTH = 0,
  GRIDLINE_HORIZONTAL = 1,
  GRIDLINE_VERTICAL = 2,
}
export enum GridLineStyle {
  GRIDLINE_NONE = 0,
  GRIDLINE_SOLID = 1,
  GRIDLINE_INSET = 2,
  GRIDLINE_RAISED = 3,
}
export enum GridTargetKind {
  GRID_TARGET_UNSPECIFIED = 0,
  GRID_TARGET_DATA_CELL = 1,
  GRID_TARGET_ROW_INDICATOR = 2,
  GRID_TARGET_COL_INDICATOR = 3,
  GRID_TARGET_CORNER_INDICATOR = 4,
  GRID_TARGET_BACKGROUND = 5,
}
export enum GroupTotalPosition {
  GROUP_TOTAL_ABOVE = 0,
  GROUP_TOTAL_BELOW = 1,
}
export enum HeaderPolicy {
  HEADER_AUTO = 0,
  HEADER_NONE = 1,
  HEADER_FIRST_ROW = 2,
}
export enum IconAlign {
  ICON_ALIGN_INLINE_END = 0,
  ICON_ALIGN_INLINE_START = 1,
  ICON_ALIGN_START = 2,
  ICON_ALIGN_END = 3,
  ICON_ALIGN_CENTER = 4,
}
export enum ImageAlignment {
  IMG_ALIGN_LEFT_TOP = 0,
  IMG_ALIGN_LEFT_CENTER = 1,
  IMG_ALIGN_LEFT_BOTTOM = 2,
  IMG_ALIGN_CENTER_TOP = 3,
  IMG_ALIGN_CENTER_CENTER = 4,
  IMG_ALIGN_CENTER_BOTTOM = 5,
  IMG_ALIGN_RIGHT_TOP = 6,
  IMG_ALIGN_RIGHT_CENTER = 7,
  IMG_ALIGN_RIGHT_BOTTOM = 8,
  IMG_ALIGN_STRETCH = 9,
  IMG_ALIGN_TILE = 10,
}
export enum IndicatorAppearance {
  INDICATOR_APPEARANCE_CLASSIC = 0,
  INDICATOR_APPEARANCE_FLAT = 1,
  INDICATOR_APPEARANCE_MODERN = 2,
}
export enum IndicatorBand {
  INDICATOR_BAND_UNSPECIFIED = 0,
  INDICATOR_BAND_ROW_START = 1,
  INDICATOR_BAND_ROW_END = 2,
  INDICATOR_BAND_COL_TOP = 3,
  INDICATOR_BAND_COL_BOTTOM = 4,
  INDICATOR_BAND_CORNER_TOP_START = 5,
  INDICATOR_BAND_CORNER_TOP_END = 6,
  INDICATOR_BAND_CORNER_BOTTOM_START = 7,
  INDICATOR_BAND_CORNER_BOTTOM_END = 8,
}
export enum InputType {
  INPUT_TYPE_TEXT = 0,
  INPUT_TYPE_NUMBER = 1,
  INPUT_TYPE_EMAIL = 2,
  INPUT_TYPE_URL = 3,
  INPUT_TYPE_PHONE = 4,
  INPUT_TYPE_PASSWORD = 5,
}
export enum KeyEvent_Type {
  KEY_TYPE_UNSPECIFIED = 0,
  KEY_DOWN = 1,
  KEY_UP = 2,
  KEY_PRESS = 3,
}
export enum LoadDataStatus {
  LOAD_OK = 0,
  LOAD_PARTIAL = 1,
  LOAD_FAILED = 2,
}
export enum NodeRelation {
  NODE_PARENT = 0,
  NODE_FIRST_CHILD = 1,
  NODE_LAST_CHILD = 2,
  NODE_NEXT_SIBLING = 3,
  NODE_PREV_SIBLING = 4,
}
export enum PinPosition {
  PIN_NONE = 0,
  PIN_TOP = 1,
  PIN_BOTTOM = 2,
}
export enum PointerEvent_Type {
  TYPE_UNSPECIFIED = 0,
  DOWN = 1,
  UP = 2,
  MOVE = 3,
}
export enum PresentMode {
  PRESENT_AUTO = 0,
  PRESENT_FIFO = 1,
  PRESENT_MAILBOX = 2,
  PRESENT_IMMEDIATE = 3,
}
export enum PrintOrientation {
  PRINT_PORTRAIT = 0,
  PRINT_LANDSCAPE = 1,
}
export enum PullToRefreshTheme {
  PULL_TO_REFRESH_THEME_UNSPECIFIED = 0,
  PULL_TO_REFRESH_THEME_TOP_BAND = 1,
  PULL_TO_REFRESH_THEME_MATERIAL = 2,
}
export enum RenderLayerBit {
  RENDER_LAYER_OVERLAY_BANDS = 0,
  RENDER_LAYER_INDICATORS = 1,
  RENDER_LAYER_BACKGROUNDS = 2,
  RENDER_LAYER_PROGRESS_BARS = 3,
  RENDER_LAYER_GRID_LINES = 4,
  RENDER_LAYER_HEADER_MARKS = 5,
  RENDER_LAYER_BACKGROUND_IMAGE = 6,
  RENDER_LAYER_CELL_BORDERS = 7,
  RENDER_LAYER_CELL_TEXT = 8,
  RENDER_LAYER_CELL_PICTURES = 9,
  RENDER_LAYER_SORT_GLYPHS = 10,
  RENDER_LAYER_COL_DRAG_MARKER = 11,
  RENDER_LAYER_CHECKBOXES = 12,
  RENDER_LAYER_DROPDOWN_BUTTONS = 13,
  RENDER_LAYER_SELECTION = 14,
  RENDER_LAYER_HOVER_HIGHLIGHT = 15,
  RENDER_LAYER_EDIT_HIGHLIGHTS = 16,
  RENDER_LAYER_FOCUS_RECT = 17,
  RENDER_LAYER_FILL_HANDLE = 18,
  RENDER_LAYER_OUTLINE = 19,
  RENDER_LAYER_FROZEN_BORDERS = 20,
  RENDER_LAYER_ACTIVE_EDITOR = 21,
  RENDER_LAYER_ACTIVE_DROPDOWN = 22,
  RENDER_LAYER_SCROLL_BARS = 23,
  RENDER_LAYER_FAST_SCROLL = 24,
  RENDER_LAYER_PULL_TO_REFRESH = 25,
  RENDER_LAYER_DEBUG_OVERLAY = 26,
  RENDER_LAYER_BARCODES = 27,
}
export enum RendererMode {
  RENDERER_AUTO = 0,
  RENDERER_CPU = 1,
  RENDERER_GPU = 2,
  RENDERER_GPU_VULKAN = 3,
  RENDERER_GPU_GLES = 4,
  RENDERER_TUI = 5,
  RENDERER_GPU_DX12 = 6,
  RENDERER_GPU_METAL = 7,
  RENDERER_GPU_OPENGL = 8,
}
export enum RowIndicatorSlotKind {
  ROW_INDICATOR_SLOT_NONE = 0,
  ROW_INDICATOR_SLOT_NUMBERS = 1,
  ROW_INDICATOR_SLOT_CURRENT = 2,
  ROW_INDICATOR_SLOT_SELECTION = 3,
  ROW_INDICATOR_SLOT_CHECKBOX = 4,
  ROW_INDICATOR_SLOT_HANDLE = 5,
  ROW_INDICATOR_SLOT_EDITING = 6,
  ROW_INDICATOR_SLOT_MODIFIED = 7,
  ROW_INDICATOR_SLOT_ERROR = 8,
  ROW_INDICATOR_SLOT_NEW_ROW = 9,
  ROW_INDICATOR_SLOT_EXPANDER = 10,
  ROW_INDICATOR_SLOT_RESIZE = 11,
  ROW_INDICATOR_SLOT_ACTION = 12,
  ROW_INDICATOR_SLOT_STATUS_ICON = 13,
  ROW_INDICATOR_SLOT_CUSTOM = 14,
  ROW_INDICATOR_SLOT_NUMBERS_DATA_ONLY = 15,
}
export enum ScrollBarAppearance {
  SCROLLBAR_APPEARANCE_CLASSIC = 0,
  SCROLLBAR_APPEARANCE_FLAT = 1,
  SCROLLBAR_APPEARANCE_MODERN = 2,
  SCROLLBAR_APPEARANCE_OVERLAY = 3,
}
export enum ScrollBarMode {
  SCROLLBAR_MODE_AUTO = 0,
  SCROLLBAR_MODE_ALWAYS = 1,
  SCROLLBAR_MODE_NEVER = 2,
}
export enum ScrollBarsMode {
  SCROLLBAR_NONE = 0,
  SCROLLBAR_HORIZONTAL = 1,
  SCROLLBAR_VERTICAL = 2,
  SCROLLBAR_BOTH = 3,
}
export enum SelectionMode {
  SELECTION_FREE = 0,
  SELECTION_BY_ROW = 1,
  SELECTION_BY_COLUMN = 2,
  SELECTION_LISTBOX = 3,
  SELECTION_MULTI_RANGE = 4,
}
export enum SelectionVisibility {
  SELECTION_VIS_NONE = 0,
  SELECTION_VIS_ALWAYS = 1,
  SELECTION_VIS_WHEN_FOCUSED = 2,
}
export enum SortOrder {
  SORT_NONE = 0,
  SORT_ASCENDING = 1,
  SORT_DESCENDING = 2,
}
export enum SortType {
  SORT_TYPE_AUTO = 0,
  SORT_TYPE_NUMERIC = 1,
  SORT_TYPE_STRING = 2,
  SORT_TYPE_STRING_NO_CASE = 3,
  SORT_TYPE_CUSTOM = 4,
}
export enum SpanCompareMode {
  SPAN_COMPARE_EXACT = 0,
  SPAN_COMPARE_NO_CASE = 1,
  SPAN_COMPARE_TRIM_NO_CASE = 2,
  SPAN_COMPARE_INCLUDE_NULLS = 3,
}
export enum StickyEdge {
  STICKY_NONE = 0,
  STICKY_TOP = 1,
  STICKY_BOTTOM = 2,
  STICKY_LEFT = 3,
  STICKY_RIGHT = 4,
  STICKY_BOTH = 5,
}
export enum TabBehavior {
  TAB_CONTROLS = 0,
  TAB_CELLS = 1,
}
export enum TerminalColorLevel {
  TERMINAL_COLOR_LEVEL_AUTO = 0,
  TERMINAL_COLOR_LEVEL_TRUECOLOR = 1,
  TERMINAL_COLOR_LEVEL_256 = 2,
  TERMINAL_COLOR_LEVEL_16 = 3,
}
export enum TerminalCommand_Kind {
  TERMINAL_COMMAND_NONE = 0,
  TERMINAL_COMMAND_EXIT = 1,
}
export enum TextBaseline {
  TEXT_BASELINE_NORMAL = 0,
  TEXT_BASELINE_SUPERSCRIPT = 1,
  TEXT_BASELINE_SUBSCRIPT = 2,
}
export enum TextEffect {
  TEXT_EFFECT_NONE = 0,
  TEXT_EFFECT_EMBOSS = 1,
  TEXT_EFFECT_ENGRAVE = 2,
  TEXT_EFFECT_EMBOSS_LIGHT = 3,
  TEXT_EFFECT_ENGRAVE_LIGHT = 4,
}
export enum TextHintingMode {
  TEXT_HINT_AUTO = 0,
  TEXT_HINT_NONE = 1,
  TEXT_HINT_SLIGHT = 2,
  TEXT_HINT_FULL = 3,
}
export enum TextRenderMode {
  TEXT_RENDER_AUTO = 0,
  TEXT_RENDER_GRAYSCALE = 1,
  TEXT_RENDER_SUBPIXEL = 2,
  TEXT_RENDER_MONO = 3,
}
export enum ThemePreset {
  THEME_NONE = 0,
  THEME_CLASSIC = 1,
  THEME_LIGHT = 2,
  THEME_DARK = 3,
  THEME_HIGH_CONTRAST = 4,
  THEME_MONOKAI = 5,
  THEME_AMBER = 6,
}
export enum TreeIndicatorStyle {
  TREE_INDICATOR_NONE = 0,
  TREE_INDICATOR_ARROWS = 1,
  TREE_INDICATOR_ARROWS_LEAF = 2,
  TREE_INDICATOR_CONNECTORS = 3,
  TREE_INDICATOR_CONNECTORS_LEAF = 4,
}
export enum TypeAheadMode {
  TYPE_AHEAD_NONE = 0,
  TYPE_AHEAD_FROM_START = 1,
  TYPE_AHEAD_FROM_CURSOR = 2,
}
export enum TypePolicy {
  TYPE_AUTO_DETECT = 0,
  TYPE_ALL_STRING = 1,
  TYPE_FROM_SCHEMA = 2,
}
export enum ValidationMode {
  VALIDATION_BLOCK = 0,
  VALIDATION_REVERT = 1,
  VALIDATION_ALLOW_INVALID = 2,
}
export enum ValidationTrigger {
  VALIDATION_TRIGGER_ON_COMMIT = 0,
  VALIDATION_TRIGGER_ON_CHANGE = 1,
  VALIDATION_TRIGGER_ON_PAUSE = 2,
  VALIDATION_TRIGGER_ON_FOCUS_LOST = 3,
}
export enum WriteErrorMode {
  WRITE_ERROR_UNSPECIFIED = 0,
  WRITE_ERROR_REJECT = 1,
  WRITE_ERROR_SET_NULL = 2,
  WRITE_ERROR_SKIP = 3,
}
export enum ZoomEvent_Phase {
  ZOOM_PHASE_UNSPECIFIED = 0,
  ZOOM_BEGIN = 1,
  ZOOM_UPDATE = 2,
  ZOOM_END = 3,
}
export const AfterEditEventFields = {
  "row": 1,
  "col": 2,
  "old_text": 3,
  "new_text": 4,
} as const;
export const AfterMoveColumnEventFields = {
  "col": 1,
  "old_position": 2,
} as const;
export const AfterMoveRowEventFields = {
  "row": 1,
  "old_position": 2,
} as const;
export const AfterNodeToggleEventFields = {
  "row": 1,
  "collapse": 2,
} as const;
export const AfterScrollEventFields = {
  "old_top_row": 1,
  "old_left_col": 2,
  "new_top_row": 3,
  "new_left_col": 4,
} as const;
export const AfterSortEventFields = {
  "col": 1,
} as const;
export const AfterTreeNodeToggleEventFields = {
  "node_id": 1,
  "row": 2,
  "collapse": 3,
} as const;
export const AfterUserFreezeEventFields = {
  "frozen_rows": 1,
  "frozen_cols": 2,
} as const;
export const AfterUserResizeEventFields = {
  "row": 1,
  "col": 2,
} as const;
export const AggregateRequestFields = {
  "grid_id": 1,
  "aggregate": 2,
  "row1": 3,
  "col1": 4,
  "row2": 5,
  "col2": 6,
} as const;
export const AggregateResponseFields = {
  "value": 1,
} as const;
export const AppendDataRequestFields = {
  "grid_id": 1,
  "data": 2,
  "options": 3,
} as const;
export const ArchiveRequestFields = {
  "grid_id": 1,
  "name": 2,
  "action": 3,
  "data": 4,
} as const;
export const ArchiveResponseFields = {
  "data": 1,
  "names": 2,
} as const;
export const AutoSizeRequestFields = {
  "grid_id": 1,
  "col_from": 2,
  "col_to": 3,
  "equal": 4,
  "max_width": 5,
} as const;
export const AutoSizeResponseFields = {
} as const;
export const BarcodeCaptionOptionsFields = {
  "position": 1,
  "text": 2,
  "color": 3,
  "font_size": 4,
} as const;
export const BarcodeDataFields = {
  "symbology": 1,
  "value": 2,
  "encoding": 3,
  "render": 4,
  "caption": 5,
} as const;
export const BarcodeEncodingOptionsFields = {
  "check_digit": 1,
  "text_encoding": 2,
  "qr_ecc": 3,
} as const;
export const BarcodeRenderOptionsFields = {
  "foreground": 1,
  "background": 2,
  "alignment": 3,
  "module_size": 4,
  "quiet_zone": 5,
  "bar_height": 10,
  "narrow_bar_width": 11,
  "show_size_warning": 12,
  "size_warning_color": 13,
  "use_full_rect": 14,
} as const;
export const BeforeEditEventFields = {
  "row": 1,
  "col": 2,
} as const;
export const BeforeMouseDownEventFields = {
  "row": 1,
  "col": 2,
  "target": 3,
} as const;
export const BeforeMoveColumnEventFields = {
  "col": 1,
  "new_position": 2,
} as const;
export const BeforeMoveRowEventFields = {
  "row": 1,
  "new_position": 2,
} as const;
export const BeforeNodeToggleEventFields = {
  "row": 1,
  "collapse": 2,
} as const;
export const BeforePageBreakEventFields = {
  "row": 1,
} as const;
export const BeforeScrollEventFields = {
  "old_top_row": 1,
  "old_left_col": 2,
  "new_top_row": 3,
  "new_left_col": 4,
} as const;
export const BeforeSortEventFields = {
  "col": 1,
} as const;
export const BeforeTreeNodeToggleEventFields = {
  "node_id": 1,
  "row": 2,
  "collapse": 3,
} as const;
export const BeforeUserResizeEventFields = {
  "row": 1,
  "col": 2,
} as const;
export const BorderFields = {
  "style": 1,
  "color": 2,
} as const;
export const BordersFields = {
  "all": 1,
  "top": 2,
  "right": 3,
  "bottom": 4,
  "left": 5,
} as const;
export const BufferReadyFields = {
  "handle": 1,
  "stride": 2,
  "width": 3,
  "height": 4,
  "capacity": 5,
} as const;
export const CellChangedEventFields = {
  "row": 1,
  "col": 2,
  "old_text": 3,
  "new_text": 4,
} as const;
export const CellDataFields = {
  "row": 1,
  "col": 2,
  "value": 3,
  "style": 4,
  "checked": 5,
  "interaction": 6,
  "barcode": 7,
  "barcode_status": 8,
  "rich_text": 9,
} as const;
export const CellEditChangeEventFields = {
  "text": 1,
} as const;
export const CellEditValidateEventFields = {
  "row": 1,
  "col": 2,
  "edit_text": 3,
} as const;
export const CellFocusChangedEventFields = {
  "old_row": 1,
  "old_col": 2,
  "new_row": 3,
  "new_col": 4,
} as const;
export const CellFocusChangingEventFields = {
  "old_row": 1,
  "old_col": 2,
  "new_row": 3,
  "new_col": 4,
} as const;
export const CellRangeFields = {
  "row1": 1,
  "col1": 2,
  "row2": 3,
  "col2": 4,
} as const;
export const CellStyleFields = {
  "background": 1,
  "foreground": 2,
  "align": 3,
  "font": 4,
  "padding": 5,
  "borders": 6,
  "text_effect": 7,
  "progress": 8,
  "progress_color": 9,
  "shrink_to_fit": 10,
} as const;
export const CellUpdateFields = {
  "row": 1,
  "col": 2,
  "value": 3,
  "style": 4,
  "checked": 5,
  "picture": 6,
  "picture_align": 7,
  "button_picture": 8,
  "editor": 9,
  "sticky_row": 10,
  "sticky_col": 11,
  "interaction": 12,
  "barcode": 13,
  "rich_text": 14,
} as const;
export const CellValueFields = {
  "text": 1,
  "number": 2,
  "flag": 3,
  "raw": 4,
  "timestamp": 5,
} as const;
export const CellsResponseFields = {
  "cells": 1,
} as const;
export const CheckboxEditorParamsFields = {
  "three_state": 1,
} as const;
export const ClearRequestFields = {
  "grid_id": 1,
  "scope": 2,
  "region": 3,
} as const;
export const ClearResponseFields = {
  "cleared_count": 1,
} as const;
export const ClickEventFields = {
  "row": 1,
  "col": 2,
  "hit_area": 3,
  "interaction": 4,
  "target": 5,
} as const;
export const ClipboardCommandFields = {
  "grid_id": 1,
  "copy": 2,
  "cut": 3,
  "paste": 4,
  "delete": 5,
} as const;
export const ClipboardCopyFields = {
} as const;
export const ClipboardCutFields = {
} as const;
export const ClipboardDeleteFields = {
} as const;
export const ClipboardPasteFields = {
  "text": 1,
  "rich_data": 2,
} as const;
export const ClipboardResponseFields = {
  "text": 1,
  "rich_data": 2,
} as const;
export const ColIndicatorCellFields = {
  "row1": 1,
  "row2": 2,
  "col1": 3,
  "col2": 4,
  "text": 5,
  "custom_key": 6,
  "data": 7,
  "modes": 8,
} as const;
export const ColIndicatorCellModesFields = {
  "modes": 1,
} as const;
export const ColIndicatorConfigFields = {
  "visible": 1,
  "default_row_height": 2,
  "band_rows": 3,
  "background": 4,
  "foreground": 5,
  "grid_lines": 6,
  "grid_color": 7,
  "auto_size": 8,
  "allow_resize": 9,
  "allow_reorder": 10,
  "allow_menu": 11,
  "row_defs": 12,
  "cells": 13,
  "cell_modes": 14,
} as const;
export const ColIndicatorRowDefFields = {
  "index": 1,
  "height": 2,
} as const;
export const ColumnDefFields = {
  "index": 1,
  "width": 2,
  "min_width": 3,
  "max_width": 4,
  "caption": 5,
  "align": 6,
  "fixed_align": 7,
  "data_type": 8,
  "format": 9,
  "key": 10,
  "sort_order": 11,
  "sort_type": 12,
  "editor": 13,
  "indent": 14,
  "hidden": 15,
  "span": 16,
  "image_list": 17,
  "data": 18,
  "sticky": 19,
  "padding": 20,
  "fixed_padding": 21,
  "nullable": 22,
  "coercion_mode": 23,
  "error_mode": 24,
  "interaction": 25,
  "progress_color": 26,
} as const;
export const CompareEventFields = {
  "request_id": 1,
  "row1": 2,
  "row2": 3,
  "col": 4,
} as const;
export const CompareResponseFields = {
  "request_id": 1,
  "result": 2,
} as const;
export const ConfigureRequestFields = {
  "grid_id": 1,
  "config": 2,
} as const;
export const ConfigureResponseFields = {
} as const;
export const CornerIndicatorConfigFields = {
  "visible": 1,
  "background": 2,
  "foreground": 3,
  "custom_key": 4,
  "data": 5,
  "slots": 6,
} as const;
export const CornerIndicatorSlotFields = {
  "kind": 1,
  "width": 2,
  "visible": 3,
  "custom_key": 4,
  "data": 5,
  "label_text": 6,
} as const;
export const CreateRequestFields = {
  "viewport_width": 1,
  "viewport_height": 2,
  "scale": 3,
  "config": 4,
} as const;
export const CreateResponseFields = {
  "grid_id": 1,
  "warnings": 2,
} as const;
export const CsvOptionsFields = {
  "delimiter": 1,
  "quote_char": 2,
  "trim_whitespace": 3,
} as const;
export const CursorChangeFields = {
  "cursor": 1,
} as const;
export const CustomEditorActionFields = {
  "action_id": 1,
  "payload": 2,
} as const;
export const CustomEditorActionEventFields = {
  "session_id": 1,
  "row": 2,
  "col": 3,
  "action_id": 4,
  "payload": 5,
} as const;
export const CustomRenderCellEventFields = {
  "row": 1,
  "col": 2,
  "x": 3,
  "y": 4,
  "width": 5,
  "height": 6,
  "text": 7,
  "style": 8,
  "done": 9,
} as const;
export const DataRefreshedEventFields = {
} as const;
export const DataRefreshingEventFields = {
} as const;
export const DateTimeEditorParamsFields = {
  "format": 1,
  "min_timestamp": 2,
  "max_timestamp": 3,
  "date_only": 4,
  "time_only": 5,
} as const;
export const DblClickEventFields = {
  "row": 1,
  "col": 2,
  "target": 3,
} as const;
export const DefineColumnsRequestFields = {
  "grid_id": 1,
  "columns": 2,
} as const;
export const DefineColumnsResponseFields = {
} as const;
export const DefineRowsRequestFields = {
  "grid_id": 1,
  "rows": 2,
} as const;
export const DefineRowsResponseFields = {
} as const;
export const DestroyRequestFields = {
  "grid_id": 1,
} as const;
export const DestroyResponseFields = {
} as const;
export const DragCompleteEventFields = {
  "success": 1,
} as const;
export const DragDropEventFields = {
  "row": 1,
  "col": 2,
} as const;
export const DragOverEventFields = {
  "row": 1,
  "col": 2,
  "x": 3,
  "y": 4,
} as const;
export const DragStartEventFields = {
  "row": 1,
  "col": 2,
} as const;
export const EditActivationFields = {
  "trigger": 1,
  "tab_behavior": 2,
  "single_click_edit": 3,
  "suppress_click_edit": 4,
  "commit_on_focus_lost": 5,
  "preserve_edit_on_navigation": 6,
} as const;
export const EditCancelFields = {
} as const;
export const EditCommandFields = {
  "grid_id": 1,
  "start": 2,
  "session": 3,
  "get_state": 4,
} as const;
export const EditCommitFields = {
  "value": 1,
} as const;
export const EditConfigFields = {
  "activation": 1,
  "default_editor": 2,
  "compose_method": 3,
} as const;
export const EditGetStateFields = {
} as const;
export const EditSetHighlightsFields = {
  "regions": 1,
} as const;
export const EditStartFields = {
  "row": 1,
  "col": 2,
  "reason": 3,
  "seed_value": 4,
  "caret_position": 5,
} as const;
export const EditStateFields = {
  "active": 1,
  "session": 2,
} as const;
export const EditValidationRequestFields = {
  "request_id": 1,
  "session_id": 2,
  "row": 3,
  "col": 4,
  "value": 5,
} as const;
export const EditValidationResponseFields = {
  "request_id": 1,
  "session_id": 2,
  "errors": 3,
  "normalized_value": 4,
} as const;
export const EditorActionFields = {
  "action_id": 1,
  "label": 2,
  "role": 3,
  "icon": 4,
} as const;
export const EditorCapabilitiesFields = {
  "accepts_text_input": 1,
  "supports_selection": 2,
  "supports_cut": 3,
  "supports_paste": 4,
  "supports_undo": 5,
} as const;
export const EditorListItemsRequestFields = {
  "request_id": 1,
  "session_id": 2,
  "data_source_id": 3,
  "filter_text": 4,
  "offset": 5,
  "limit": 6,
} as const;
export const EditorListItemsResponseFields = {
  "request_id": 1,
  "session_id": 2,
  "items": 3,
  "has_more": 4,
} as const;
export const EditorPreeditChangedFields = {
  "text": 1,
  "cursor": 2,
  "commit": 3,
} as const;
export const EditorSessionFields = {
  "session_id": 1,
  "row": 2,
  "col": 3,
  "viewport_rect": 4,
  "editor": 5,
  "value": 6,
  "selection": 7,
  "ui_mode": 8,
  "capabilities": 9,
  "reason": 10,
  "state_version": 11,
  "composing": 12,
  "preedit_text": 13,
  "validation_errors": 14,
} as const;
export const EditorSessionCommandFields = {
  "session_id": 1,
  "state_version": 2,
  "value_changed": 3,
  "selection_changed": 4,
  "preedit_changed": 5,
  "commit": 6,
  "cancel": 7,
  "custom_action": 8,
} as const;
export const EditorSessionEndedFields = {
  "session_id": 1,
  "reason": 2,
  "committed_value": 3,
  "state_version": 4,
} as const;
export const EditorSessionStartedFields = {
  "session": 1,
} as const;
export const EditorSessionUpdatedFields = {
  "session_id": 1,
  "state_version": 2,
  "reason": 3,
  "viewport_rect": 4,
  "value": 5,
  "selection": 6,
  "visible": 7,
  "force_refocus": 8,
  "validation_errors": 9,
  "custom_payload": 10,
} as const;
export const EditorSpecFields = {
  "kind": 1,
  "owner": 2,
  "presentation": 3,
  "validation_mode": 4,
  "validation_trigger": 5,
  "validation_debounce_ms": 6,
  "custom_editor_id": 10,
  "text": 11,
  "number": 12,
  "checkbox": 13,
  "list": 14,
  "date_time": 15,
  "actions": 16,
  "custom_props": 17,
} as const;
export const EditorValueFields = {
  "value": 1,
  "edit_text": 2,
  "display_text": 3,
} as const;
export const EditorValueChangedFields = {
  "value": 1,
} as const;
export const EnterCellEventFields = {
  "row": 1,
  "col": 2,
  "target": 3,
} as const;
export const ErrorEventFields = {
  "code": 1,
  "message": 2,
} as const;
export const EventDecisionFields = {
  "grid_id": 1,
  "event_id": 2,
  "cancel": 3,
} as const;
export const EventStreamRequestFields = {
  "grid_id": 1,
} as const;
export const ExportRequestFields = {
  "grid_id": 1,
  "format": 2,
  "scope": 3,
} as const;
export const ExportResponseFields = {
  "data": 1,
  "format": 2,
} as const;
export const FieldMappingFields = {
  "field": 1,
  "col_index": 2,
  "col_key": 3,
} as const;
export const FilterDataEventFields = {
  "row": 1,
  "col": 2,
  "text": 3,
} as const;
export const FindRequestFields = {
  "grid_id": 1,
  "col": 2,
  "start_row": 3,
  "text_query": 4,
  "regex_query": 5,
} as const;
export const FindResponseFields = {
  "row": 1,
} as const;
export const FontFields = {
  "family": 1,
  "families": 2,
  "size": 3,
  "bold": 4,
  "italic": 5,
  "underline": 6,
  "strikethrough": 7,
  "stretch": 8,
} as const;
export const FrameDoneFields = {
  "handle": 1,
  "dirty_x": 2,
  "dirty_y": 3,
  "dirty_w": 4,
  "dirty_h": 5,
  "metrics": 6,
  "bytes_written": 7,
  "required_capacity": 8,
  "frame_kind": 9,
} as const;
export const FrameMetricsFields = {
  "frame_time_ms": 1,
  "fps": 2,
  "layer_times_us": 3,
  "zone_cell_counts": 4,
  "instance_count": 5,
} as const;
export const FreezePolicyFields = {
  "columns": 1,
  "rows": 2,
} as const;
export const GetCellsRequestFields = {
  "grid_id": 1,
  "row1": 2,
  "col1": 3,
  "row2": 4,
  "col2": 5,
  "include_style": 6,
  "include_checked": 7,
  "include_typed": 8,
  "include_barcode_status": 9,
  "include_rich_text": 10,
} as const;
export const GetConfigRequestFields = {
  "grid_id": 1,
} as const;
export const GetDemoDataRequestFields = {
  "demo": 1,
} as const;
export const GetDemoDataResponseFields = {
  "demo": 1,
  "format": 2,
  "data": 3,
} as const;
export const GetHeaderRowEventFields = {
  "page": 1,
} as const;
export const GetMemoryUsageRequestFields = {
  "grid_id": 1,
} as const;
export const GetMergedRangeRequestFields = {
  "grid_id": 1,
  "row": 2,
  "col": 3,
} as const;
export const GetMergedRegionsRequestFields = {
  "grid_id": 1,
} as const;
export const GetNodeRequestFields = {
  "grid_id": 1,
  "row": 2,
  "relation": 3,
} as const;
export const GetSchemaRequestFields = {
  "grid_id": 1,
} as const;
export const GetSelectionRequestFields = {
  "grid_id": 1,
} as const;
export const GpuFrameDoneFields = {
  "dirty_x": 1,
  "dirty_y": 2,
  "dirty_w": 3,
  "dirty_h": 4,
  "metrics": 5,
} as const;
export const GpuSurfaceReadyFields = {
  "surface_handle": 1,
  "width": 2,
  "height": 3,
} as const;
export const GridConfigFields = {
  "layout": 1,
  "style": 2,
  "selection": 3,
  "editing": 4,
  "scrolling": 5,
  "outline": 6,
  "span": 7,
  "interaction": 8,
  "rendering": 9,
  "version": 10,
  "indicators": 11,
  "theme_preset": 12,
} as const;
export const GridEventFields = {
  "grid_id": 1,
  "event_id": 100,
  "cell_focus_changing": 2,
  "cell_focus_changed": 3,
  "selection_changing": 4,
  "selection_changed": 5,
  "enter_cell": 6,
  "leave_cell": 7,
  "before_edit": 8,
  "start_edit": 9,
  "after_edit": 10,
  "cell_edit_validate": 11,
  "cell_edit_change": 12,
  "key_down_edit": 13,
  "key_press_edit": 14,
  "key_up_edit": 15,
  "edit_validation_request": 16,
  "editor_list_items_request": 17,
  "custom_editor_action": 18,
  "cell_changed": 19,
  "row_status_change": 20,
  "before_sort": 21,
  "after_sort": 22,
  "compare": 23,
  "before_node_toggle": 24,
  "after_node_toggle": 25,
  "before_scroll": 26,
  "after_scroll": 27,
  "scroll_tooltip": 28,
  "before_user_resize": 29,
  "after_user_resize": 30,
  "after_user_freeze": 31,
  "before_move_column": 32,
  "after_move_column": 33,
  "before_move_row": 34,
  "after_move_row": 35,
  "before_mouse_down": 36,
  "mouse_down": 37,
  "mouse_up": 38,
  "mouse_move": 39,
  "click": 40,
  "dbl_click": 41,
  "key_down": 42,
  "key_press": 43,
  "key_up": 44,
  "custom_render_cell": 45,
  "drag_start": 46,
  "drag_over": 47,
  "drag_drop": 48,
  "drag_complete": 49,
  "type_ahead_started": 50,
  "type_ahead_ended": 51,
  "data_refreshing": 52,
  "data_refreshed": 53,
  "filter_data": 54,
  "error": 55,
  "before_page_break": 56,
  "start_page": 57,
  "get_header_row": 58,
  "pull_to_refresh_triggered": 59,
  "pull_to_refresh_canceled": 60,
  "tree_children_requested": 61,
  "before_tree_node_toggle": 62,
  "after_tree_node_toggle": 63,
  "tree_node_activate": 64,
  "tree_node_context_menu": 65,
} as const;
export const GridEventTargetFields = {
  "kind": 1,
  "band": 2,
  "slot_index": 3,
  "slot_kind": 4,
  "custom_key": 5,
  "text": 6,
  "int_value": 7,
  "status_flags": 8,
  "data": 9,
  "sub_mode": 10,
} as const;
export const GridLinesFields = {
  "style": 1,
  "direction": 2,
  "color": 3,
  "width": 4,
} as const;
export const HeaderFeaturesFields = {
  "sort": 1,
  "reorder": 2,
  "chooser": 3,
} as const;
export const HeaderMarkSizeFields = {
  "ratio": 1,
  "px": 2,
} as const;
export const HeaderResizeHandleFields = {
  "enabled": 1,
  "color": 2,
  "width": 3,
  "height": 4,
  "hit_width": 5,
  "show_only_when_resizable": 6,
} as const;
export const HeaderSeparatorFields = {
  "enabled": 1,
  "color": 2,
  "width": 3,
  "height": 4,
  "skip_merged": 5,
} as const;
export const HeaderStyleFields = {
  "separator": 1,
  "resize_handle": 2,
} as const;
export const HighlightRegionFields = {
  "range": 1,
  "style": 2,
  "ref_id": 3,
  "text_start": 4,
  "text_length": 5,
} as const;
export const HighlightStyleFields = {
  "background": 1,
  "foreground": 2,
  "borders": 3,
  "fill_handle": 4,
  "fill_handle_color": 5,
} as const;
export const HoverConfigFields = {
  "row": 1,
  "column": 2,
  "cell": 3,
  "row_style": 4,
  "column_style": 5,
  "cell_style": 6,
} as const;
export const IconPicturesFields = {
  "sort_ascending": 1,
  "sort_descending": 2,
  "node_open": 3,
  "node_closed": 4,
  "checkbox_checked": 5,
  "checkbox_unchecked": 6,
  "checkbox_indeterminate": 7,
} as const;
export const IconSlotStylesFields = {
  "sort_ascending": 1,
  "sort_descending": 2,
  "sort_none": 3,
  "tree_expanded": 4,
  "tree_collapsed": 5,
  "menu": 6,
  "filter": 7,
  "filter_active": 8,
  "columns": 9,
  "drag_handle": 10,
  "checkbox_checked": 11,
  "checkbox_unchecked": 12,
  "checkbox_indeterminate": 13,
} as const;
export const IconSlotsFields = {
  "sort_ascending": 1,
  "sort_descending": 2,
  "sort_none": 3,
  "tree_expanded": 4,
  "tree_collapsed": 5,
  "menu": 6,
  "filter": 7,
  "filter_active": 8,
  "columns": 9,
  "drag_handle": 10,
  "checkbox_checked": 11,
  "checkbox_unchecked": 12,
  "checkbox_indeterminate": 13,
} as const;
export const IconStyleFields = {
  "font": 1,
  "color": 2,
  "align": 3,
  "gap": 4,
} as const;
export const IconThemeFields = {
  "slots": 1,
  "defaults": 2,
  "overrides": 3,
  "pictures": 4,
} as const;
export const ImageDataFields = {
  "data": 1,
  "format": 2,
} as const;
export const IndicatorColorsFields = {
  "background": 1,
  "foreground": 2,
  "grid": 3,
  "button_background": 4,
  "button_foreground": 5,
  "button_border": 6,
  "button_pressed_background": 7,
  "button_pressed_foreground": 8,
  "button_pressed_border_dark": 9,
  "button_pressed_border_light": 10,
  "button_hover_background": 11,
  "button_hover_foreground": 12,
  "button_hover_border": 13,
} as const;
export const IndicatorFocusConfigFields = {
  "enable_keyboard_focus": 1,
  "enter_key_code": 2,
  "exit_key_code": 3,
} as const;
export const IndicatorsConfigFields = {
  "row_start": 1,
  "row_end": 2,
  "col_top": 3,
  "col_bottom": 4,
  "corner_top_start": 5,
  "corner_top_end": 6,
  "corner_bottom_start": 7,
  "corner_bottom_end": 8,
  "focus": 9,
  "appearance": 10,
  "colors": 11,
} as const;
export const InsertRowsRequestFields = {
  "grid_id": 1,
  "index": 2,
  "count": 3,
  "text": 4,
} as const;
export const InsertRowsResponseFields = {
  "inserted_count": 1,
  "new_row_count": 2,
  "first_row": 3,
} as const;
export const InteractionConfigFields = {
  "resize": 1,
  "freeze": 2,
  "type_ahead": 3,
  "type_ahead_delay": 4,
  "auto_size_mouse": 5,
  "auto_size_mode": 6,
  "auto_resize": 7,
  "drag_mode": 8,
  "drop_mode": 9,
  "header_features": 10,
  "decision_timeout_ms": 11,
  "compare_response_timeout_ms": 12,
} as const;
export const JsonOptionsFields = {
  "data_path": 1,
} as const;
export const KeyDownEditEventFields = {
  "session_id": 1,
  "key_code": 2,
  "modifier": 3,
} as const;
export const KeyDownEventFields = {
  "key_code": 1,
  "modifier": 2,
} as const;
export const KeyEventFields = {
  "type": 1,
  "key_code": 2,
  "modifier": 3,
  "character": 4,
} as const;
export const KeyPressEditEventFields = {
  "session_id": 1,
  "key_ascii": 2,
} as const;
export const KeyPressEventFields = {
  "key_ascii": 1,
} as const;
export const KeyUpEditEventFields = {
  "session_id": 1,
  "key_code": 2,
  "modifier": 3,
} as const;
export const KeyUpEventFields = {
  "key_code": 1,
  "modifier": 2,
} as const;
export const LayoutConfigFields = {
  "rows": 1,
  "cols": 2,
  "fixed_rows": 3,
  "fixed_cols": 4,
  "frozen_rows": 5,
  "frozen_cols": 6,
  "default_row_height": 7,
  "default_col_width": 8,
  "right_to_left": 9,
  "extend_last_col": 10,
} as const;
export const LeaveCellEventFields = {
  "row": 1,
  "col": 2,
  "target": 3,
} as const;
export const ListDataSourceFields = {
  "data_source_id": 1,
  "filterable": 2,
  "pageable": 3,
  "page_size": 4,
} as const;
export const ListEditorParamsFields = {
  "static_items": 1,
  "data_source": 2,
  "allow_custom_value": 3,
  "searchable": 4,
  "multi_select": 5,
  "item_layout": 6,
} as const;
export const ListItemFields = {
  "value": 1,
  "label": 2,
  "details": 3,
  "disabled": 4,
} as const;
export const LoadDataOptionsFields = {
  "csv": 1,
  "json": 2,
  "header_policy": 10,
  "field_map": 11,
  "type_policy": 12,
  "coercion": 13,
  "error_mode": 14,
  "date_format": 15,
  "decimal_char": 16,
  "auto_create_columns": 17,
  "atomic": 19,
  "skip_rows": 20,
  "max_rows": 21,
} as const;
export const LoadDataRequestFields = {
  "grid_id": 1,
  "data": 2,
  "options": 3,
} as const;
export const LoadDataResultFields = {
  "status": 1,
  "rows": 2,
  "cols": 3,
  "rejected": 4,
  "violations": 5,
  "warnings": 6,
  "inferred_columns": 7,
} as const;
export const LoadDemoRequestFields = {
  "grid_id": 1,
  "demo": 2,
} as const;
export const LoadDemoResponseFields = {
} as const;
export const LoadFontDataRequestFields = {
  "data": 1,
  "font_name": 2,
  "font_names": 3,
} as const;
export const LoadFontDataResponseFields = {
} as const;
export const LoadTableRequestFields = {
  "grid_id": 1,
  "rows": 2,
  "cols": 3,
  "values": 4,
  "atomic": 5,
} as const;
export const MemoryUsageResponseFields = {
  "total_bytes": 1,
  "cell_data_bytes": 2,
  "style_bytes": 3,
  "layout_bytes": 4,
  "column_bytes": 5,
  "row_bytes": 6,
  "selection_bytes": 7,
  "animation_bytes": 8,
  "text_engine_bytes": 9,
  "event_bytes": 10,
  "misc_bytes": 11,
  "cell_count": 12,
  "rows": 13,
  "cols": 14,
} as const;
export const MergeCellsRequestFields = {
  "grid_id": 1,
  "range": 2,
} as const;
export const MergeCellsResponseFields = {
  "merged": 1,
} as const;
export const MergedRegionsResponseFields = {
  "ranges": 1,
} as const;
export const MouseDownEventFields = {
  "button": 1,
  "modifier": 2,
  "x": 3,
  "y": 4,
} as const;
export const MouseMoveEventFields = {
  "button": 1,
  "modifier": 2,
  "x": 3,
  "y": 4,
  "target": 5,
} as const;
export const MouseUpEventFields = {
  "button": 1,
  "modifier": 2,
  "x": 3,
  "y": 4,
} as const;
export const MoveColumnRequestFields = {
  "grid_id": 1,
  "col": 2,
  "position": 3,
} as const;
export const MoveColumnResponseFields = {
} as const;
export const MoveRowRequestFields = {
  "grid_id": 1,
  "row": 2,
  "position": 3,
} as const;
export const MoveRowResponseFields = {
} as const;
export const NodeInfoFields = {
  "row": 1,
  "level": 2,
  "is_expanded": 3,
  "child_count": 4,
  "parent_row": 5,
  "first_child": 6,
  "last_child": 7,
} as const;
export const NumberEditorParamsFields = {
  "min": 1,
  "max": 2,
  "step": 3,
  "format": 4,
  "nullable": 5,
} as const;
export const OutlineConfigFields = {
  "tree_indicator": 1,
  "tree_color": 2,
  "group_total_position": 3,
  "multi_totals": 4,
  "indicator_indent": 5,
  "max_levels": 6,
  "show_level_buttons": 7,
  "label_column": 8,
  "icon_column": 9,
} as const;
export const OutlineRequestFields = {
  "grid_id": 1,
  "level": 2,
} as const;
export const OutlineResponseFields = {
} as const;
export const PaddingFields = {
  "left": 1,
  "top": 2,
  "right": 3,
  "bottom": 4,
} as const;
export const PointerEventFields = {
  "type": 1,
  "x": 2,
  "y": 3,
  "modifier": 4,
  "button": 5,
  "dbl_click": 6,
} as const;
export const PrintPageFields = {
  "page_number": 1,
  "image_data": 2,
  "width": 3,
  "height": 4,
} as const;
export const PrintRequestFields = {
  "grid_id": 1,
  "orientation": 2,
  "margin_left": 3,
  "margin_top": 4,
  "margin_right": 5,
  "margin_bottom": 6,
  "header": 7,
  "footer": 8,
  "show_page_numbers": 9,
} as const;
export const PrintResponseFields = {
  "pages": 1,
} as const;
export const PullToRefreshCanceledEventFields = {
} as const;
export const PullToRefreshConfigFields = {
  "enabled": 1,
  "theme": 2,
  "text_pull": 3,
  "text_release": 4,
} as const;
export const PullToRefreshTriggeredEventFields = {
} as const;
export const RectFields = {
  "x": 1,
  "y": 2,
  "width": 3,
  "height": 4,
} as const;
export const RefreshRequestFields = {
  "grid_id": 1,
} as const;
export const RefreshResponseFields = {
} as const;
export const RegexQueryFields = {
  "pattern": 1,
} as const;
export const RegionStyleFields = {
  "background": 1,
  "foreground": 2,
  "font": 3,
  "grid_lines": 4,
  "text_effect": 5,
  "separator": 6,
  "cell_padding": 7,
} as const;
export const RemoveRowsRequestFields = {
  "grid_id": 1,
  "index": 2,
  "count": 3,
} as const;
export const RemoveRowsResponseFields = {
  "removed_count": 1,
  "new_row_count": 2,
} as const;
export const RenderConfigFields = {
  "renderer_mode": 1,
  "debug_overlay": 2,
  "animation_enabled": 3,
  "animation_duration_ms": 4,
  "text_layout_cache_cap": 5,
  "present_mode": 6,
  "frame_pacing_mode": 7,
  "target_frame_rate_hz": 8,
  "render_layer_mask": 9,
  "layer_profiling": 10,
  "scroll_blit": 11,
  "font_fallback_enabled": 12,
} as const;
export const RenderInputFields = {
  "grid_id": 1,
  "viewport": 2,
  "pointer": 3,
  "key": 4,
  "buffer": 5,
  "scroll": 6,
  "event_decision": 7,
  "zoom": 8,
  "gpu_surface": 9,
  "terminal_input": 10,
  "terminal_capabilities": 11,
  "terminal_viewport": 12,
  "terminal_command": 13,
  "compare_response": 14,
  "edit_validation_response": 15,
  "editor_list_items_response": 16,
} as const;
export const RenderOutputFields = {
  "rendered": 1,
  "frame_done": 2,
  "selection": 3,
  "cursor": 4,
  "editor_started": 5,
  "editor_updated": 6,
  "editor_ended": 7,
  "tooltip_request": 8,
  "gpu_frame_done": 9,
} as const;
export const ResizePolicyFields = {
  "columns": 1,
  "rows": 2,
  "uniform": 3,
} as const;
export const ResizeViewportRequestFields = {
  "grid_id": 1,
  "width": 2,
  "height": 3,
} as const;
export const ResizeViewportResponseFields = {
  "viewport_width": 1,
  "viewport_height": 2,
} as const;
export const RichTextFields = {
  "runs": 1,
} as const;
export const RowDefFields = {
  "index": 1,
  "height": 2,
  "hidden": 3,
  "is_subtotal": 4,
  "outline_level": 5,
  "is_collapsed": 6,
  "data": 7,
  "status": 8,
  "span": 9,
  "pin": 10,
  "sticky": 11,
} as const;
export const RowIndicatorConfigFields = {
  "visible": 1,
  "width": 2,
  "background": 3,
  "foreground": 4,
  "grid_lines": 5,
  "grid_color": 6,
  "auto_size": 7,
  "allow_resize": 8,
  "allow_select": 9,
  "allow_reorder": 10,
  "slots": 11,
} as const;
export const RowIndicatorSlotFields = {
  "kind": 1,
  "width": 2,
  "visible": 3,
  "custom_key": 4,
  "data": 5,
} as const;
export const RowStatusFields = {
  "domain": 1,
  "code": 2,
} as const;
export const RowStatusChangeEventFields = {
  "row": 1,
  "status": 2,
} as const;
export const ScalarValueFields = {
  "string_value": 1,
  "number_value": 2,
  "bool_value": 3,
  "bytes_value": 4,
} as const;
export const SchemaResponseFields = {
  "columns": 1,
} as const;
export const ScrollBarColorsFields = {
  "thumb": 1,
  "thumb_hover": 2,
  "thumb_active": 3,
  "track": 4,
  "arrow": 5,
  "border": 6,
} as const;
export const ScrollBarConfigFields = {
  "show_h": 1,
  "show_v": 2,
  "appearance": 3,
  "size": 4,
  "min_thumb": 5,
  "corner_radius": 6,
  "colors": 7,
  "fade_delay_ms": 8,
  "fade_duration_ms": 9,
  "margin": 10,
} as const;
export const ScrollConfigFields = {
  "scroll_bar": 1,
  "scroll_track": 2,
  "scroll_tips": 3,
  "fling_enabled": 4,
  "fling_impulse_gain": 5,
  "fling_friction": 6,
  "pinch_zoom_enabled": 7,
  "fast_scroll": 8,
  "scrollbars": 9,
  "pull_to_refresh": 10,
} as const;
export const ScrollEventFields = {
  "delta_x": 1,
  "delta_y": 2,
} as const;
export const ScrollTooltipEventFields = {
  "text": 1,
} as const;
export const SelectRequestFields = {
  "grid_id": 1,
  "active_row": 2,
  "active_col": 3,
  "ranges": 4,
  "show": 5,
} as const;
export const SelectResponseFields = {
  "selection": 1,
} as const;
export const SelectionChangedEventFields = {
  "old_ranges": 1,
  "new_ranges": 2,
  "active_row": 3,
  "active_col": 4,
} as const;
export const SelectionChangingEventFields = {
  "old_ranges": 1,
  "new_ranges": 2,
  "active_row": 3,
  "active_col": 4,
} as const;
export const SelectionConfigFields = {
  "mode": 1,
  "focus_border": 2,
  "visibility": 3,
  "allow": 4,
  "header_click_select": 5,
  "style": 6,
  "hover": 7,
  "indicator_row_style": 8,
  "indicator_col_style": 9,
  "active_cell_style": 10,
} as const;
export const SelectionStateFields = {
  "active_row": 1,
  "active_col": 2,
  "ranges": 3,
  "top_row": 4,
  "left_col": 5,
  "bottom_row": 6,
  "right_col": 7,
  "mouse_row": 8,
  "mouse_col": 9,
} as const;
export const SelectionUpdateFields = {
  "active_row": 1,
  "active_col": 2,
  "ranges": 3,
} as const;
export const SeparatorFields = {
  "visible": 1,
  "color": 2,
  "width": 3,
} as const;
export const SetColRequestFields = {
  "grid_id": 1,
  "col": 2,
} as const;
export const SetLeftColResponseFields = {
  "left_col": 1,
} as const;
export const SetRedrawRequestFields = {
  "grid_id": 1,
  "enabled": 2,
} as const;
export const SetRedrawResponseFields = {
} as const;
export const SetRowRequestFields = {
  "grid_id": 1,
  "row": 2,
} as const;
export const SetTopRowResponseFields = {
  "top_row": 1,
} as const;
export const ShowCellRequestFields = {
  "grid_id": 1,
  "row": 2,
  "col": 3,
} as const;
export const ShowCellResponseFields = {
  "top_row": 1,
  "left_col": 2,
} as const;
export const SortColumnFields = {
  "col": 1,
  "order": 2,
  "type": 3,
} as const;
export const SortRequestFields = {
  "grid_id": 1,
  "sort_columns": 2,
} as const;
export const SortResponseFields = {
} as const;
export const SpanConfigFields = {
  "cell_span": 1,
  "cell_span_fixed": 2,
  "cell_span_compare": 3,
  "group_span_compare": 4,
} as const;
export const StartEditEventFields = {
  "row": 1,
  "col": 2,
} as const;
export const StartPageEventFields = {
  "page": 1,
} as const;
export const StructFieldFields = {
  "key": 1,
  "value": 2,
} as const;
export const StructValueFields = {
  "fields": 1,
} as const;
export const StyleConfigFields = {
  "background": 1,
  "foreground": 2,
  "alternate_background": 3,
  "font": 4,
  "cell_padding": 5,
  "text_effect": 6,
  "progress_color": 7,
  "grid_lines": 10,
  "fixed": 11,
  "frozen": 12,
  "header": 13,
  "sheet_background": 20,
  "sheet_border": 21,
  "appearance": 22,
  "background_image": 23,
  "background_image_align": 24,
  "text_rendering": 25,
  "icons": 30,
  "image_over_text": 31,
  "show_sort_numbers": 32,
  "apply_scope": 33,
  "custom_render": 34,
  "format": 40,
  "word_wrap": 41,
  "ellipsis": 42,
  "text_overflow": 43,
} as const;
export const SubtotalRequestFields = {
  "grid_id": 1,
  "aggregate": 2,
  "group_on_col": 3,
  "aggregate_col": 4,
  "caption": 5,
  "background": 6,
  "foreground": 7,
  "add_outline": 8,
  "font": 9,
} as const;
export const SubtotalResultFields = {
  "rows": 1,
} as const;
export const TerminalCapabilitiesFields = {
  "color_level": 1,
  "sgr_mouse": 2,
  "focus_events": 3,
  "bracketed_paste": 4,
} as const;
export const TerminalCommandFields = {
  "kind": 1,
} as const;
export const TerminalInputBytesFields = {
  "data": 1,
} as const;
export const TerminalViewportFields = {
  "origin_x": 1,
  "origin_y": 2,
  "width": 3,
  "height": 4,
  "fullscreen": 5,
} as const;
export const TextEditorParamsFields = {
  "max_length": 1,
  "mask": 2,
  "allow_newlines": 3,
  "input_type": 4,
} as const;
export const TextFormatRunFields = {
  "start_index": 1,
  "style": 2,
} as const;
export const TextQueryFields = {
  "text": 1,
  "case_sensitive": 2,
  "full_match": 3,
} as const;
export const TextRenderingFields = {
  "mode": 1,
  "hinting": 2,
  "pixel_snap": 3,
} as const;
export const TextRunStyleFields = {
  "foreground": 1,
  "font": 2,
  "baseline": 3,
  "link_url": 4,
} as const;
export const TextSelectionFields = {
  "start": 1,
  "length": 2,
} as const;
export const TextSelectionChangedFields = {
  "selection": 1,
} as const;
export const TooltipRequestFields = {
  "x": 1,
  "y": 2,
  "text": 3,
} as const;
export const TreeChildrenRequestedEventFields = {
  "node_id": 1,
  "row": 2,
  "request_id": 3,
} as const;
export const TreeNodeActivateEventFields = {
  "node_id": 1,
  "row": 2,
} as const;
export const TreeNodeContextMenuEventFields = {
  "node_id": 1,
  "row": 2,
  "x": 3,
  "y": 4,
} as const;
export const TypeAheadEndedEventFields = {
} as const;
export const TypeAheadStartedEventFields = {
  "col": 1,
  "text": 2,
} as const;
export const TypeViolationFields = {
  "row": 1,
  "col": 2,
  "expected": 3,
  "actual": 4,
  "reason": 5,
} as const;
export const UnmergeCellsRequestFields = {
  "grid_id": 1,
  "range": 2,
} as const;
export const UnmergeCellsResponseFields = {
  "unmerged_count": 1,
} as const;
export const UpdateCellsRequestFields = {
  "grid_id": 1,
  "cells": 2,
  "atomic": 3,
} as const;
export const ValidationErrorFields = {
  "code": 1,
  "message": 2,
  "blocking": 3,
} as const;
export const ViewportStateFields = {
  "scroll_x": 1,
  "scroll_y": 2,
  "width": 3,
  "height": 4,
} as const;
export const WriteResultFields = {
  "written_count": 1,
  "rejected_count": 2,
  "violations": 3,
} as const;
export const ZoomEventFields = {
  "phase": 1,
  "scale": 2,
  "focal_x_px": 3,
  "focal_y_px": 4,
} as const;
export const VolvoxGridServiceMethods = {
  Create: "/volvoxgrid.v1.VolvoxGridService/Create",
  Destroy: "/volvoxgrid.v1.VolvoxGridService/Destroy",
  Configure: "/volvoxgrid.v1.VolvoxGridService/Configure",
  GetConfig: "/volvoxgrid.v1.VolvoxGridService/GetConfig",
  LoadFontData: "/volvoxgrid.v1.VolvoxGridService/LoadFontData",
  DefineColumns: "/volvoxgrid.v1.VolvoxGridService/DefineColumns",
  GetSchema: "/volvoxgrid.v1.VolvoxGridService/GetSchema",
  DefineRows: "/volvoxgrid.v1.VolvoxGridService/DefineRows",
  InsertRows: "/volvoxgrid.v1.VolvoxGridService/InsertRows",
  RemoveRows: "/volvoxgrid.v1.VolvoxGridService/RemoveRows",
  MoveColumn: "/volvoxgrid.v1.VolvoxGridService/MoveColumn",
  MoveRow: "/volvoxgrid.v1.VolvoxGridService/MoveRow",
  UpdateCells: "/volvoxgrid.v1.VolvoxGridService/UpdateCells",
  GetCells: "/volvoxgrid.v1.VolvoxGridService/GetCells",
  LoadTable: "/volvoxgrid.v1.VolvoxGridService/LoadTable",
  LoadData: "/volvoxgrid.v1.VolvoxGridService/LoadData",
  AppendData: "/volvoxgrid.v1.VolvoxGridService/AppendData",
  Clear: "/volvoxgrid.v1.VolvoxGridService/Clear",
  Select: "/volvoxgrid.v1.VolvoxGridService/Select",
  GetSelection: "/volvoxgrid.v1.VolvoxGridService/GetSelection",
  ShowCell: "/volvoxgrid.v1.VolvoxGridService/ShowCell",
  SetTopRow: "/volvoxgrid.v1.VolvoxGridService/SetTopRow",
  SetLeftCol: "/volvoxgrid.v1.VolvoxGridService/SetLeftCol",
  Edit: "/volvoxgrid.v1.VolvoxGridService/Edit",
  Sort: "/volvoxgrid.v1.VolvoxGridService/Sort",
  Subtotal: "/volvoxgrid.v1.VolvoxGridService/Subtotal",
  AutoSize: "/volvoxgrid.v1.VolvoxGridService/AutoSize",
  Outline: "/volvoxgrid.v1.VolvoxGridService/Outline",
  GetNode: "/volvoxgrid.v1.VolvoxGridService/GetNode",
  Find: "/volvoxgrid.v1.VolvoxGridService/Find",
  Aggregate: "/volvoxgrid.v1.VolvoxGridService/Aggregate",
  GetMergedRange: "/volvoxgrid.v1.VolvoxGridService/GetMergedRange",
  MergeCells: "/volvoxgrid.v1.VolvoxGridService/MergeCells",
  UnmergeCells: "/volvoxgrid.v1.VolvoxGridService/UnmergeCells",
  GetMergedRegions: "/volvoxgrid.v1.VolvoxGridService/GetMergedRegions",
  GetMemoryUsage: "/volvoxgrid.v1.VolvoxGridService/GetMemoryUsage",
  Clipboard: "/volvoxgrid.v1.VolvoxGridService/Clipboard",
  Export: "/volvoxgrid.v1.VolvoxGridService/Export",
  Print: "/volvoxgrid.v1.VolvoxGridService/Print",
  Archive: "/volvoxgrid.v1.VolvoxGridService/Archive",
  ResizeViewport: "/volvoxgrid.v1.VolvoxGridService/ResizeViewport",
  SetRedraw: "/volvoxgrid.v1.VolvoxGridService/SetRedraw",
  Refresh: "/volvoxgrid.v1.VolvoxGridService/Refresh",
  LoadDemo: "/volvoxgrid.v1.VolvoxGridService/LoadDemo",
  GetDemoData: "/volvoxgrid.v1.VolvoxGridService/GetDemoData",
  RenderSession: "/volvoxgrid.v1.VolvoxGridService/RenderSession",
  EventStream: "/volvoxgrid.v1.VolvoxGridService/EventStream",
} as const;

// ─────────────────────────────────────────────────────────────────────────────
// FFI host abstraction
// ─────────────────────────────────────────────────────────────────────────────
// Implemented by the consumer (e.g. a wasm-backed host or a native bridge).
// Each unary RPC sends a serialized request and receives a serialized response;
// streams are handed off to the host via openStream.
//
// `serviceName` is the bare service identifier (e.g. "VolvoxGridService").
// `methodName` is the fully-qualified gRPC method path
// (e.g. "/volvoxgrid.v1.VolvoxGridService/Create").

export interface PluginHost {
  invoke(serviceName: string, methodName: string, data: Uint8Array): Uint8Array;
  openStream(serviceName: string, methodName: string): PluginStream;
}

export interface PluginStream {
  send(data: Uint8Array): void;
  /** Returns null once the server has closed the stream. */
  recv(): Uint8Array | null;
  closeSend(): void;
  close(): void;
}

export class VolvoxGridServiceFfi {
  constructor(private readonly host: PluginHost) {}

  create(request: pb.CreateRequest): pb.CreateResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/Create",
      request.toBinary(),
    );
    return pb.CreateResponse.fromBinary(result);
  }

  destroy(request: pb.DestroyRequest): pb.DestroyResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/Destroy",
      request.toBinary(),
    );
    return pb.DestroyResponse.fromBinary(result);
  }

  configure(request: pb.ConfigureRequest): pb.ConfigureResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/Configure",
      request.toBinary(),
    );
    return pb.ConfigureResponse.fromBinary(result);
  }

  getConfig(request: pb.GetConfigRequest): pb.GridConfig {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/GetConfig",
      request.toBinary(),
    );
    return pb.GridConfig.fromBinary(result);
  }

  loadFontData(request: pb.LoadFontDataRequest): pb.LoadFontDataResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/LoadFontData",
      request.toBinary(),
    );
    return pb.LoadFontDataResponse.fromBinary(result);
  }

  defineColumns(request: pb.DefineColumnsRequest): pb.DefineColumnsResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/DefineColumns",
      request.toBinary(),
    );
    return pb.DefineColumnsResponse.fromBinary(result);
  }

  getSchema(request: pb.GetSchemaRequest): pb.SchemaResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/GetSchema",
      request.toBinary(),
    );
    return pb.SchemaResponse.fromBinary(result);
  }

  defineRows(request: pb.DefineRowsRequest): pb.DefineRowsResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/DefineRows",
      request.toBinary(),
    );
    return pb.DefineRowsResponse.fromBinary(result);
  }

  insertRows(request: pb.InsertRowsRequest): pb.InsertRowsResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/InsertRows",
      request.toBinary(),
    );
    return pb.InsertRowsResponse.fromBinary(result);
  }

  removeRows(request: pb.RemoveRowsRequest): pb.RemoveRowsResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/RemoveRows",
      request.toBinary(),
    );
    return pb.RemoveRowsResponse.fromBinary(result);
  }

  moveColumn(request: pb.MoveColumnRequest): pb.MoveColumnResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/MoveColumn",
      request.toBinary(),
    );
    return pb.MoveColumnResponse.fromBinary(result);
  }

  moveRow(request: pb.MoveRowRequest): pb.MoveRowResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/MoveRow",
      request.toBinary(),
    );
    return pb.MoveRowResponse.fromBinary(result);
  }

  updateCells(request: pb.UpdateCellsRequest): pb.WriteResult {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/UpdateCells",
      request.toBinary(),
    );
    return pb.WriteResult.fromBinary(result);
  }

  getCells(request: pb.GetCellsRequest): pb.CellsResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/GetCells",
      request.toBinary(),
    );
    return pb.CellsResponse.fromBinary(result);
  }

  loadTable(request: pb.LoadTableRequest): pb.WriteResult {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/LoadTable",
      request.toBinary(),
    );
    return pb.WriteResult.fromBinary(result);
  }

  loadData(request: pb.LoadDataRequest): pb.LoadDataResult {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/LoadData",
      request.toBinary(),
    );
    return pb.LoadDataResult.fromBinary(result);
  }

  appendData(request: pb.AppendDataRequest): pb.LoadDataResult {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/AppendData",
      request.toBinary(),
    );
    return pb.LoadDataResult.fromBinary(result);
  }

  clear(request: pb.ClearRequest): pb.ClearResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/Clear",
      request.toBinary(),
    );
    return pb.ClearResponse.fromBinary(result);
  }

  select(request: pb.SelectRequest): pb.SelectResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/Select",
      request.toBinary(),
    );
    return pb.SelectResponse.fromBinary(result);
  }

  getSelection(request: pb.GetSelectionRequest): pb.SelectionState {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/GetSelection",
      request.toBinary(),
    );
    return pb.SelectionState.fromBinary(result);
  }

  showCell(request: pb.ShowCellRequest): pb.ShowCellResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/ShowCell",
      request.toBinary(),
    );
    return pb.ShowCellResponse.fromBinary(result);
  }

  setTopRow(request: pb.SetRowRequest): pb.SetTopRowResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/SetTopRow",
      request.toBinary(),
    );
    return pb.SetTopRowResponse.fromBinary(result);
  }

  setLeftCol(request: pb.SetColRequest): pb.SetLeftColResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/SetLeftCol",
      request.toBinary(),
    );
    return pb.SetLeftColResponse.fromBinary(result);
  }

  edit(request: pb.EditCommand): pb.EditState {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/Edit",
      request.toBinary(),
    );
    return pb.EditState.fromBinary(result);
  }

  sort(request: pb.SortRequest): pb.SortResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/Sort",
      request.toBinary(),
    );
    return pb.SortResponse.fromBinary(result);
  }

  subtotal(request: pb.SubtotalRequest): pb.SubtotalResult {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/Subtotal",
      request.toBinary(),
    );
    return pb.SubtotalResult.fromBinary(result);
  }

  autoSize(request: pb.AutoSizeRequest): pb.AutoSizeResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/AutoSize",
      request.toBinary(),
    );
    return pb.AutoSizeResponse.fromBinary(result);
  }

  outline(request: pb.OutlineRequest): pb.OutlineResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/Outline",
      request.toBinary(),
    );
    return pb.OutlineResponse.fromBinary(result);
  }

  getNode(request: pb.GetNodeRequest): pb.NodeInfo {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/GetNode",
      request.toBinary(),
    );
    return pb.NodeInfo.fromBinary(result);
  }

  find(request: pb.FindRequest): pb.FindResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/Find",
      request.toBinary(),
    );
    return pb.FindResponse.fromBinary(result);
  }

  aggregate(request: pb.AggregateRequest): pb.AggregateResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/Aggregate",
      request.toBinary(),
    );
    return pb.AggregateResponse.fromBinary(result);
  }

  getMergedRange(request: pb.GetMergedRangeRequest): pb.CellRange {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/GetMergedRange",
      request.toBinary(),
    );
    return pb.CellRange.fromBinary(result);
  }

  mergeCells(request: pb.MergeCellsRequest): pb.MergeCellsResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/MergeCells",
      request.toBinary(),
    );
    return pb.MergeCellsResponse.fromBinary(result);
  }

  unmergeCells(request: pb.UnmergeCellsRequest): pb.UnmergeCellsResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/UnmergeCells",
      request.toBinary(),
    );
    return pb.UnmergeCellsResponse.fromBinary(result);
  }

  getMergedRegions(request: pb.GetMergedRegionsRequest): pb.MergedRegionsResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/GetMergedRegions",
      request.toBinary(),
    );
    return pb.MergedRegionsResponse.fromBinary(result);
  }

  getMemoryUsage(request: pb.GetMemoryUsageRequest): pb.MemoryUsageResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/GetMemoryUsage",
      request.toBinary(),
    );
    return pb.MemoryUsageResponse.fromBinary(result);
  }

  clipboard(request: pb.ClipboardCommand): pb.ClipboardResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/Clipboard",
      request.toBinary(),
    );
    return pb.ClipboardResponse.fromBinary(result);
  }

  export(request: pb.ExportRequest): pb.ExportResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/Export",
      request.toBinary(),
    );
    return pb.ExportResponse.fromBinary(result);
  }

  print(request: pb.PrintRequest): pb.PrintResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/Print",
      request.toBinary(),
    );
    return pb.PrintResponse.fromBinary(result);
  }

  archive(request: pb.ArchiveRequest): pb.ArchiveResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/Archive",
      request.toBinary(),
    );
    return pb.ArchiveResponse.fromBinary(result);
  }

  resizeViewport(request: pb.ResizeViewportRequest): pb.ResizeViewportResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/ResizeViewport",
      request.toBinary(),
    );
    return pb.ResizeViewportResponse.fromBinary(result);
  }

  setRedraw(request: pb.SetRedrawRequest): pb.SetRedrawResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/SetRedraw",
      request.toBinary(),
    );
    return pb.SetRedrawResponse.fromBinary(result);
  }

  refresh(request: pb.RefreshRequest): pb.RefreshResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/Refresh",
      request.toBinary(),
    );
    return pb.RefreshResponse.fromBinary(result);
  }

  loadDemo(request: pb.LoadDemoRequest): pb.LoadDemoResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/LoadDemo",
      request.toBinary(),
    );
    return pb.LoadDemoResponse.fromBinary(result);
  }

  getDemoData(request: pb.GetDemoDataRequest): pb.GetDemoDataResponse {
    const result = this.host.invoke(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/GetDemoData",
      request.toBinary(),
    );
    return pb.GetDemoDataResponse.fromBinary(result);
  }

  renderSession(): VolvoxGridServiceRenderSessionStream {
    const stream = this.host.openStream(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/RenderSession",
    );
    return {
      send(request: pb.RenderInput): void {
        stream.send(request.toBinary());
      },
      recv(): pb.RenderOutput | null {
        const data = stream.recv();
        return data == null ? null : pb.RenderOutput.fromBinary(data);
      },
      closeSend(): void { stream.closeSend(); },
      close(): void { stream.close(); },
    };
  }

  *eventStream(request: pb.EventStreamRequest): Generator<pb.GridEvent, void, undefined> {
    const stream = this.host.openStream(
      "VolvoxGridService",
      "/volvoxgrid.v1.VolvoxGridService/EventStream",
    );
    try {
      stream.send(request.toBinary());
      stream.closeSend();
      while (true) {
        const data = stream.recv();
        if (data == null) return;
        yield pb.GridEvent.fromBinary(data);
      }
    } finally {
      stream.close();
    }
  }

}

export interface VolvoxGridServiceRenderSessionStream {
  send(request: pb.RenderInput): void;
  recv(): pb.RenderOutput | null;
  closeSend(): void;
  close(): void;
}

